// extracted by mini-css-extract-plugin
export var numpadContainer = "_qv-1";
export var phoneButton = "_qv-0";